import { CSSProperties } from "react"
import { css } from "@emotion/css"

const styles = {
  wrapper: css`
    width: 100%;
    min-width: 120px;
    position: relative;
    height: var(--h);
    display: grid;
  `,
  track: css`
    grid-area: 1 / -1;
    width: 100%;
    height: 100%;
    border-radius: var(--r);
    background-color: var(--track-color, #e7e6e6);
  `,
  bar: css`
    grid-area: 1 / -1;
    height: 100%;
    display: flex;
    overflow: hidden;
    width: var(--w);
    border-radius: var(--r);
    background-color: var(--color, #00b1a4);
  `,
}

export type ProgressBarProps = {
  value: number
  thickness?: number
  radius?: number
  color?: string
  trackColor?: string
}

export function ProgressBar(props: ProgressBarProps) {
  const { value, thickness = 6, radius, color, trackColor } = props
  const w = Number(value.toFixed(2))
  const h = thickness
  const r = radius || h / 2

  const style = {
    "--w": `${w}%`,
    "--h": `${h}px`,
    "--r": `${r}px`,
    "--color": color || "var(--primary-main, #00b1a4)",
    "--track-color": trackColor || "var(--light-grey, #e7e6e6)",
  } as CSSProperties

  return (
    <div data-wrapper style={style} className={styles.wrapper}>
      <div data-track className={styles.track} />
      <div data-bar className={styles.bar} />
    </div>
  )
}
